import { render, staticRenderFns } from "./MandateData.vue?vue&type=template&id=61d48d40&"
import script from "./MandateData.vue?vue&type=script&lang=js&"
export * from "./MandateData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports